import { render, staticRenderFns } from "./TrademarkNoteForm.vue?vue&type=template&id=3c61be46&"
import script from "./TrademarkNoteForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNoteForm.vue?vue&type=style&index=0&id=3c61be46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports